<template>
  <div class="devOps_producerSpaceSet">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="姓名" prop="project_system" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle"  @change="formSearch('reset')" v-model="form.user" collapse-tags filterable
                   placeholder="请选择姓名" clearable>
          <el-option v-for="(key, value) in allSelect.TEXTALLUSERSEN" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="组织" prop="reviewer" :label-width="formLabelWidth">
        <el-select :style="iptStyle"  filterable clearable collapse-tags size="mini" v-model="form.org" @change="formSearch('reset')"  placeholder="请选择角色">
          <el-option v-for="(key, value) in allSelect.USERCORD" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>-->
      <div>
        <el-form-item style="margin-left: 20px">
          <el-button style="font-weight: bold;font-size: 12px;" type="primary"
                     @click="showDialogVisible('update', {})">新增人员
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <div style="height: 75vh">
  <el-table
      height="100%"
      :data="tableData"
      >
    <el-table-column prop="username" label="姓名">
      <template slot-scope="scope">
        {{scope.row.cn }}({{scope.row.username}})
      </template>
    </el-table-column>
    <el-table-column prop="orgs" label="末级组织">
    </el-table-column>
    <el-table-column prop="position" label="角色">
    </el-table-column>
    <el-table-column prop="user_state" label="状态">
    </el-table-column>
    <el-table-column
        label="操作">
      <template slot-scope="scope">
        <div style="display: flex;">
          <el-button type="primary" size="mini" @click="showDialogVisible('update', scope.row)">编辑</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <Detaile  v-if="dialogVisible.update" :dialogVisible='dialogVisible.update' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></Detaile>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getDevOpsSpaceDevopsUserApi} from "@/server/tops/devOps";
export default {
  components: { },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        user:'',
      },
      dialogVisible:{
        update: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
    }
  },
  async created() {
    await this.getNewData();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
  },
  methods: {
    async getNewData(){
      let params = {}
      params.page_num = this.currentPage
      params.page_size = this.pageSize
      params.name = this.form.user;
      getDevOpsSpaceDevopsUserApi(params).then((res)=>{
        this.tableData = res.data.project_lists;
        this.total = res.data.num_all_count;
      })
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      this.dialogVisible[type] = true;
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceSet{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
</style>
